import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// AssetMaster
import BaseMixer from "../../BaseMixer";
import { IAssetTypeDTO } from "@/store/models/asset/assetType";
import { AssetMasterModule } from "@/store/modules/asset.module";
import { Guid } from "guid-typescript";
import _ from "lodash";
let AssetMasterUpsertComponent = /** @class */ (() => {
    var _a;
    let AssetMasterUpsertComponent = class AssetMasterUpsertComponent extends Mixins(BaseMixer) {
        checkAndSendSave() {
            this.validateProvider("AssetMasterObserver").then((res) => {
                if (res) {
                    return this.save();
                }
            });
        }
        save() { }
        cancel() { }
        get assetCategory() {
            return AssetMasterModule.assetCategory;
        }
        get sortedAssetCategory() {
            return _.sortBy(this.assetCategory, (o) => o.value);
        }
        assetCategorySelection() {
            if (this.model.assetCategoryId != null) {
                this.model.assetCategoryName = this.assetCategory.find((x) => x.id == Guid.parse(this.model.assetCategoryId)).value;
            }
        }
        created() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IAssetTypeDTO !== "undefined" && IAssetTypeDTO) === "function" ? _a : Object)
    ], AssetMasterUpsertComponent.prototype, "model", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetMasterUpsertComponent.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AssetMasterUpsertComponent.prototype, "cancel", null);
    AssetMasterUpsertComponent = __decorate([
        Component({
            name: "AssetMasterUpsertComponent",
        })
    ], AssetMasterUpsertComponent);
    return AssetMasterUpsertComponent;
})();
export default AssetMasterUpsertComponent;
